// Auto-generated by scripts/build-dicts.mjs — DO NOT EDIT
export const CHUNK_3_WORDS: Record<number, string> = {
  9: "leftmosts"
};
